<div class="breadcrumbs">
	@for (crumb of breadcrumbs(); track crumb.route; let i = $index; let last = $last) {
		<div class="breadcrumb" [attr.data-label]="crumb.label">
			@if (crumb.userUuid) {
				<a (click)="navigate(crumb.route)" class="active">
					{{ crumb.displayName ?? 'Loading...' }}
				</a>
			} @else {
				<a (click)="navigate(crumb.route)" class="active">
					{{ crumb.name }}
				</a>
			}

			@if (!last) {
				<span class="separator">&gt;</span>
			}
		</div>
	}

	<div class="avatar-container">
		<app-avatar />
	</div>
</div>
